module.exports = __webpack_public_path__ + "static/media/milk-full-header.1c9e7c91.png";